"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGuidedLearningTasksResponse = exports.isGuidedLearningTasksResponse = exports.GuidedLearningTasksResponseSchema = exports.GuidedLearningProgressNumbersSchema = exports.isGuidedLearningProgress = exports.GuidedLearningChapterUserQuoteSchema = exports.GuidedLearningChapterQuoteSchema = exports.GuidedLearningProgressSchema = exports.GuidedLearningQuoteDefinitionSchema = exports.GuidedLearningTaskDefinitionSchema = exports.isGuidedLearningVideoDefinition = exports.GuidedLearningVideoDefinitionSchema = exports.GuidedLearningNonVideoTaskDefinitionSchema = exports.BaseGuidedLearningTaskDefinitionSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const language_codes_types_1 = require("./language_codes_types");
const topic_types_1 = require("./topic_types");
const GuidedLearningNonVideoTaskCategorySchema = zod_1.z.union([
    zod_1.z.literal("LEARN"),
    zod_1.z.literal("CREATE"),
    zod_1.z.literal("REVIEW"),
]);
const GuidedLearningNonVideoTaskTypeSchema = zod_1.z.union([
    zod_1.z.literal("SET_REMINDERS"),
    zod_1.z.literal("EAR_TRAINER_FLOW"),
    zod_1.z.literal("PRONUNCIATION"),
    zod_1.z.literal("REVIEW_FLOW"),
    zod_1.z.literal("CREATE_WORD_ONLY"),
    zod_1.z.literal("CREATE_VOCAB"),
    zod_1.z.literal("REVIEW"),
    zod_1.z.literal("CREATE_GRAMMAR"),
    zod_1.z.literal("CREATE_TOPIC_FLASHCARDS"),
]);
exports.BaseGuidedLearningTaskDefinitionSchema = zod_1.z.object({
    chapter: zod_1.z.number(),
    duration: zod_1.z.number().optional(),
    id: zod_1.z.string(),
    isAccountLevelTask: zod_1.z.boolean(),
    minSupportedAppVersion: zod_1.z.string().optional(),
    title: zod_1.z.string().optional(),
    topicId: topic_types_1.TopicIdSchema.optional(),
    week: zod_1.z.number(),
});
exports.GuidedLearningNonVideoTaskDefinitionSchema = exports.BaseGuidedLearningTaskDefinitionSchema.extend({
    category: GuidedLearningNonVideoTaskCategorySchema,
    type: GuidedLearningNonVideoTaskTypeSchema,
});
exports.GuidedLearningVideoDefinitionSchema = exports.BaseGuidedLearningTaskDefinitionSchema.extend({
    category: zod_1.z.literal("LEARN"),
    duration: zod_1.z.number(),
    title: zod_1.z.string(),
    transcript: zod_1.z.string(),
    type: zod_1.z.literal("VIDEO"),
    videoId: zod_1.z.string(),
    videoUrl: zod_1.z.string(),
});
exports.isGuidedLearningVideoDefinition = type_validation_helpers_1.getTypeValidationFunction(exports.GuidedLearningVideoDefinitionSchema);
exports.GuidedLearningTaskDefinitionSchema = zod_1.z.union([
    exports.GuidedLearningNonVideoTaskDefinitionSchema,
    exports.GuidedLearningVideoDefinitionSchema,
]);
exports.GuidedLearningQuoteDefinitionSchema = zod_1.z.object({
    chapter: zod_1.z.number(),
    text: zod_1.z.string(),
    week: zod_1.z.number(),
});
const LanguagesLastCompletedTaskSchema = zod_1.z.object(language_codes_types_1.languagePairCodes.reduce((acc, languagePairCode) => ({
    ...acc,
    [languagePairCode]: zod_1.z.string().optional(),
}), {}));
exports.GuidedLearningProgressSchema = zod_1.z.object({
    languagesLastCompletedTask: LanguagesLastCompletedTaskSchema.optional(),
    lastCompletedAccountTask: zod_1.z.string().optional(),
});
exports.GuidedLearningChapterQuoteSchema = zod_1.z.object({
    chapter: zod_1.z.number(),
    claps: zod_1.z.number(),
    dismissed: zod_1.z.boolean(),
    week: zod_1.z.number(),
});
exports.GuidedLearningChapterUserQuoteSchema = exports.GuidedLearningChapterQuoteSchema.extend({
    text: zod_1.z.string(),
});
exports.isGuidedLearningProgress = type_validation_helpers_1.getVerboseTypeValidationFunction(exports.GuidedLearningProgressSchema);
exports.GuidedLearningProgressNumbersSchema = zod_1.z.object({
    completedChapters: zod_1.z.number(),
    currentWeekProgress: zod_1.z.number(),
    isLastChapterInCurrentWeek: zod_1.z.boolean(),
    totalChapters: zod_1.z.number(),
});
exports.GuidedLearningTasksResponseSchema = zod_1.z.object({
    progress: exports.GuidedLearningProgressNumbersSchema.optional(),
    quote: exports.GuidedLearningChapterUserQuoteSchema.optional(),
    tasks: zod_1.z.array(exports.GuidedLearningTaskDefinitionSchema),
});
exports.isGuidedLearningTasksResponse = type_validation_helpers_1.getVerboseTypeValidationFunction(exports.GuidedLearningTasksResponseSchema);
const validateGuidedLearningTasksResponse = (x) => exports.GuidedLearningTasksResponseSchema.safeParse(x);
exports.validateGuidedLearningTasksResponse = validateGuidedLearningTasksResponse;
//# sourceMappingURL=guided_learning_types.js.map